import React from 'react';
import { Row, Col } from 'react-bootstrap';

function SeeMore({
  title = '',
  subtitle = '',
  subtitle2 = '',
  GeneralColor = '',
  onRequest = false,
  subtitle2FontSize = '14px'
}) {
  const styling = {
    stroke: GeneralColor,
    strokeDasharray: `${101} 100`,
    animationName: 'Fill',
    animationDuration: '2s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'forwards'
  };
  return (
    <>
      {!onRequest && (
        <div style={{ height: '85px' }}>
          <Row style={{ alignItems: 'center' }}>
            <Col xs={4} md={4} xl={4}>
              <div className="Percentage">
                <svg width="100" height="100">
                  <circle className="circle" r="30%" cx="50%" cy="50%" pathLength="100" style={{ stroke: '#adadad' }} />
                  <circle className="circle" r="30%" cx="50%" cy="50%" pathLength="100" style={styling} />
                </svg>
                <span style={{ color: '#000', alignSelf: 'center', fontSize: 20 }}>{title}</span>
              </div>
            </Col>
            <Col xs={8} md={8} xl={8}>
              <p style={{ fontSize: subtitle2FontSize, fontWeight: 'bold', color: 'black' }}>{subtitle2}</p>
              <p style={{ fontSize: '9px', fontWeight: 'bold', color: 'black' }}>{subtitle}</p>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}

export default SeeMore;
